import { isArray, isBoolean, isEmpty } from 'lodash';

export const errorMessage = __('This field is required');

export const validateRequired = (value) => {
  let error;

  if (
    (!isBoolean(value) && !value && value !== 0) ||
    (typeof value === 'string' && value.trim() === '')
  ) {
    error = errorMessage;
  }

  return error;
};

export const validateRequiredForArray = (value) => {
  let error;

  if (!isArray(value) || isEmpty(value)) {
    error = errorMessage;
  }

  return error;
};

export const validateRequiredForCheckbox = (value) => {
  let error;

  if (value === 'true') {
    return error;
  }

  error = errorMessage;

  return error;
};
